import axios from 'axios';

const API_URL = 'https://outlook.plus94research.co.za/api/';

const authService = {
    login: async (username, password) => {
        try {
            const response = await axios.post(`${API_URL}login/`, {
                username,
                password,
            });
            if (response.data.token) {
                localStorage.setItem('token', response.data.token);
                axios.defaults.headers.common['Authorization'] = `Token ${response.data.token}`;
            }
            return response.data;
        } catch (error) {
            localStorage.removeItem('token');
            delete axios.defaults.headers.common['Authorization'];
            throw error;
        }
    },

    logout: async () => {
        try {
            const token = localStorage.getItem('token');
            if (token) {
                await axios.post(`${API_URL}logout/`, {}, {
                    headers: { Authorization: `Token ${token}` },
                });
            }
        } finally {
            localStorage.removeItem('token');
            delete axios.defaults.headers.common['Authorization'];
            axios.defaults.headers.common['Authorization'] = null;
        }
    },

    getCurrentUser: async () => {
        const token = localStorage.getItem('token');
        if (!token) return null;

        try {
            const response = await axios.get(`${API_URL}verify-token/`, {
                headers: { Authorization: `Token ${token}` }
            });
            return response.data;
        } catch {
            localStorage.removeItem('token');
            delete axios.defaults.headers.common['Authorization'];
            return null;
        }
    },

    isAuthenticated: async () => {
        return await authService.getCurrentUser() !== null;
    }
};

export default authService;
